import { render, staticRenderFns } from "./ResponseAnswerBlock.vue?vue&type=template&id=6612faeb&scoped=true"
import script from "./ResponseAnswerBlock.vue?vue&type=script&lang=js"
export * from "./ResponseAnswerBlock.vue?vue&type=script&lang=js"
import style0 from "./ResponseAnswerBlock.vue?vue&type=style&index=0&id=6612faeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6612faeb",
  null
  
)

export default component.exports